import { useState, useEffect, memo ,useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./SendFriendInvite.module.scss";
import * as YStyled from "../../Styleds";
import { CSSTransition } from 'react-transition-group';
import { Snackbar, Alert } from '@mui/material';
import { GameContext } from "../../GameContext";
const SendFriendInvite = ({ setModalType }) => {
    const [inProp, setInProp] = useState(false);
    const { userData } = useContext(GameContext);
    const [inviteLink, setInviteLink] = useState(`${window.location.origin}`);///f/${userData.users_id}
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
        setInProp(true);
        document.title = "發送好友邀請連結";
    }, []);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(inviteLink).then(() => {
            setSnackbarOpen(true);
        }).catch(err => {
            console.error("複製到剪貼簿失敗：", err);
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    return (
        <div className={style.modal}>
            <CSSTransition
                in={inProp}
                timeout={{ appear: 0, enter: 300, exit: 0 }}
                classNames={{
                    enterActive: style.SwipePageEnterActive,
                    enterDone: style.SwipePageEnterDone,
                    exitActive: style.SwipePageExit,
                    exitDone: style.SwipePageExitActive
                }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "SendFriendInvite"));
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`}>
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                        </div>
                        <div className={styleUi.view}>
                            <img src="./assets/ui/gift.png" style={{ alignSelf: "flex-end", marginTop: "2rem" }} />
                            <YStyled.Span size={22} fontWeight={600} style={{ alignSelf: "flex-start", marginTop: "1rem" }}>你的邀請連結</YStyled.Span>
                            <YStyled.Label style={{ width: "100%", marginTop: "1rem" }}>
                                <YStyled.Row>
                                    <YStyled.Span style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        flexGrow: "1",
                                    }} size={13} color="#3149CE">{inviteLink}</YStyled.Span>
                                    <YStyled.BTN3
                                        normalBg="#F5F6FD"
                                        normalColor="#3149CE"
                                        disableBg="#00000088"
                                        disableColor="#FFF"
                                        style={{ padding: ".4rem .5rem", borderWidth: "0px", borderRadius: "10px" }}
                                        onClick={handleCopyLink}
                                    >
                                        <YStyled.Row gap=".3rem">
                                            <YStyled.Span size={17}>複製</YStyled.Span>
                                            <img src="./assets/ui/copy_blue.svg" />
                                        </YStyled.Row>
                                    </YStyled.BTN3>
                                </YStyled.Row>
                            </YStyled.Label>
                            <YStyled.Span size={17} fontWeight={400} style={{ alignSelf: "flex-start", marginTop: "1rem" }}>傳送你的邀請連結，給你的親友！</YStyled.Span>
                            <YStyled.BTN3
                                normalBg="#000"
                                normalColor="white"
                                disableBg="#00000088"
                                disableColor="#FFF"
                                style={{ padding: ".8rem", borderWidth: "0px", borderRadius: "35px", marginTop: "3rem" }}
                                onClick={async () => {
                                    if (navigator.share) {
                                        try {
                                            await navigator.share({
                                                title: '分享标题',
                                                text: '分享描述',
                                                url: inviteLink // 你想要分享的网址
                                            });
                                            console.log('分享成功');
                                        } catch (error) {
                                            console.log('分享失败', error);
                                        }
                                    }
                                }}
                            >
                                <YStyled.Span size={17}>傳送邀請</YStyled.Span>
                            </YStyled.BTN3>
                        </div>
                    </div>
                </div>
            </CSSTransition>

            <Snackbar
    open={snackbarOpen}
    autoHideDuration={2000}
    onClose={handleCloseSnackbar}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
>
    <Alert 
        sx={{ 
            width: '100%', 
            backgroundColor: '#ffffff', 
            color: '#000000', 
            padding: '8px 16px', 
            fontWeight:'500',
        }}
        icon={false} // 移除图标
    >
        連結已複製
    </Alert>
</Snackbar>


        </div>
    );
};

export default memo(SendFriendInvite);
